/**
 * HTTP statuses the API client reacts to.
 *
 * `PAYMENT_REQUIRED` is reserved for quota breaches: the caller is
 * authenticated and allowed, the action simply needs a bigger plan or a paid
 * event package. It is deliberately distinct from `FORBIDDEN`, which means the
 * action is not permitted at all.
 */
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  TOO_MANY_REQUESTS: 429,
} as const;
